export enum MemberView {
	GRID = 'grid',
	LIST = 'list',
}

export default {
	MemberView,
};
